/**
 * Faux face type enum.
 *
 * @type {{HAND_LABELED_PUB: string, MACHINE_LABELED_PUB: string, TIME_LINK: string, MATCHING_TAG: string}}
 */
export const FAUX_FACE_TYPE = {
  HAND_LABELED_PUB: 'HAND_LABELED_PUB',
  MACHINE_LABELED_PUB: 'MACHINE_LABELED_PUB',
  TIME_LINK: 'TIME_LINK',
  MATCHING_TAG: 'MATCHING_TAG',
};
